<template>
    <a v-if="outerPath" :href="outerPath" target="_blank" class="sidenav-item-container" v-bind="$attrs">
        <div
            class="sidenav-item-icon"
        >
            <slot name="icon"/>
        </div>
        <div class="sidenav-item-text">{{ navText }}</div>
    </a>
    <router-link v-else :to="url" class="sidenav-item-container" v-bind="$attrs">
        <div
            class="sidenav-item-icon"
        >
            <slot name="icon"/>
        </div>
        <div class="sidenav-item-text" :class="isDentium ? 'dentium' : ''">
            {{ navText }}
            <img v-if="isDentium" src="@/assets/img/sidenav/badge_Dentium.svg"/>
        </div>
    </router-link>
</template>
<script>
    export default {
        name: 'sidenav-item',
        props: {
            url: {
                type: String,
                required: false
            },
            navText: {
                type: String,
                required: true
            },
            outerPath: {
                type: String,
                required: false
            },
            isDentium: {
                type: Boolean,
                required: false
            },
        }
    };
</script>
